<template>
<div>
  <v-container fluid class="pa-2">
    <div class="d-flex align-center justify-space-between mb-4">
      <div>
        <h2 class="section-title">
        {{this.$t('ApiClientManagement.ApiClientManagementTitle')}}
        </h2>
        <div class="text-h6 font-weight-bold"></div>
        <div class="text-caption grey--text">
        </div>
      </div>

      <div class="d-flex align-center" style="gap: 12px;">
        <v-btn color="primary" @click="openCreate">
        <v-icon left>mdi-plus</v-icon>
        {{this.$t('ApiClientManagement.buttonNewApiClient')}}
        </v-btn>

        <v-text-field
          v-model="search"
          dense
          outlined
          hide-details
          prepend-inner-icon="mdi-magnify"
          placeholder="Search"
          style="width: 320px;"
        />
      </div>
    </div>

    <v-card class="table-card" outlined>
      <v-data-table
        :headers="getheaders"
        :items="filteredItems"
        :items-per-page="itemsPerPage"
        :page.sync="page"
        class="elevation-1"
        hide-default-footer
      >
        <template v-slot:item.no="{ index }">
          {{ (page - 1) * itemsPerPage + index + 1 }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon small text elevation="0" color="primary" @click="openEdit(item)">
            <v-icon small>mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn icon small text elevation="0" color="orange" @click="resetSecretClientKey(item)">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
          <v-btn icon small text elevation="0" color="red" @click="confirmDeleteClient(item)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.scopes="{ item }">
          <v-chip
            v-for="(s, i) in item.scopes"
            :key="i"
            small
            class="mr-1"
            color="#EEF2FF"
            text-color="#1E40AF"
          >
            {{ s }}
          </v-chip>
        </template>

        <template v-slot:item.ipWhitelist="{ item }">
          <span class="grey--text text--darken-2">
            {{ item.ipWhitelist || "-" }}
          </span>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip
            small
            :color="item.isActive ? 'green' : 'red'"
            text-color="white"
            class="status-chip"
          >
            {{ item.isActive ? 'Active' : 'Inactive' }}
          </v-chip>
        </template>

        <template v-slot:item.expireDate="{ item }">
          <span class="grey--text text--darken-2">{{ item.expireDate || "-" }}</span>
        </template>

        <template v-slot:item.createdAt="{ item }">
          <span class="grey--text text--darken-2">{{ item.createdAt }}</span>
        </template>

        <template v-slot:item.updatedAt="{ item }">
          <span class="grey--text text--darken-2">{{ item.updatedAt }}</span>
        </template>

        <template v-slot:no-data>
          <div class="pa-6 text-center grey--text">No clients found</div>
        </template>
      </v-data-table>

      <div class="d-flex align-center justify-space-between px-4 py-3 footer-bar">
        <div class="text-caption grey--text">
          Showing {{ showingFrom }}-{{ showingTo }} of {{ filteredItems.length }} clients
        </div>

        <div class="d-flex align-center" style="gap: 10px;">
          <v-btn icon small text elevation="0" :disabled="page <= 1" @click="page--">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <div class="text-caption grey--text text--darken-2">
            Page {{ page }} of {{ totalPages }}
          </div>

          <v-btn icon small text elevation="0" :disabled="page >= totalPages" @click="page++">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-container>

  <!-- Create / Edit Client Dialog -->
  <v-dialog v-model="dialog.open" max-width="720" persistent >
    <v-card class="dialog-card">
      <v-btn
        icon
        class="dialog-close-btn"
        @click="closeDialog"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Title -->
      <v-card-title class="pb-0">
        <span class="text-h4 font-weight-bold">
          {{ dialog.mode === 'create' ? this.$t('ApiClientManagement.buttonNewApiClient') : this.$t('ApiClientManagement.buttonEditApiClient') }}
        </span>
      </v-card-title>

      <v-divider class="mt-1" />

      <!-- Content -->
      <v-card-text>
        <v-form
          ref="clientForm"
          v-model="dialog.valid"
          lazy-validation
        >
          <v-row dense>
          <!-- CREATE MODE -->
          <template v-if="dialog.mode === 'create'">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.clientName"
                :label="this.$t('ApiClientManagement.clientName')"
                outlined dense
                :rules="[rules.required]"
                required
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.contactEmail"
                :label="this.$t('ApiClientManagement.contactEmail')"
                outlined dense
                :rules="[rules.required, rules.email]"
                required
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.ipWhitelist"
                :label="this.$t('ApiClientManagement.ipAdress')"
                outlined dense
                hint="รองรับหลาย IP เช่น 10.0.0.1, 10.0.0.2"
                persistent-hint
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.authType"
                :label="this.$t('Authen Type')"
                outlined dense
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="form.callbackEndpoint"
                :label="this.$t('Callback Endpoint')"
                outlined dense
              />
            </v-col>
            
            <v-col cols="12">
              <v-textarea
                v-model="form.authSecret"
                :label="$t('Authen Secret')"
                outlined
                dense
                rows="3"
                auto-grow
                clearable
              />
            </v-col>
          </template>

          <!-- EDIT MODE -->
          <template v-else>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.clientId"
                label="Client ID"
                outlined
                dense
                disabled
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.clientName"
                :label="this.$t('ApiClientManagement.clientName')"
                outlined 
                dense
                disabled
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.contactEmail"
                :label="this.$t('ApiClientManagement.contactEmail')"
                outlined dense
                :rules="[rules.email]"
              />
            </v-col>

            <v-col cols="12" md="6">
              <!-- ถ้าอยากเป็น text ธรรมดาให้ใช้ v-text-field -->
              <v-autocomplete
                v-model="form.scopes"
                :items="scopeOptions"
                label="Scopes"
                multiple
                chips
                small-chips
                clearable
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.ipWhitelist"
                :label="this.$t('ApiClientManagement.ipAdress')"
                outlined dense
                hint="รองรับหลาย IP เช่น 10.0.0.1, 10.0.0.2"
                persistent-hint
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.authType"
                :label="this.$t('ApiClientManagement.authType')"
                outlined dense
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="form.callbackEndpoint"
                :label="this.$t('ApiClientManagement.callbackEndpoint')"
                outlined dense
              />
            </v-col>
            
            <v-col cols="12">
              <v-textarea
                v-model="form.authSecret"
                :label="$t('ApiClientManagement.authSecret')"
                outlined
                dense
                rows="3"
                auto-grow
                clearable
              />
            </v-col>

             <v-col cols="12" md="6">
                <!-- Date Picker -->
                <v-menu
                v-model="expireMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
                content-class="expire-menu"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.expireDate"
                      label="Expire Date"
                      outlined
                      dense
                      readonly
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      @click="openExpireMenu"
                      @click:clear="form.expireDate = null"
                    />
                  </template>

                  <v-card>
                    <v-date-picker
                      v-model="expireDateTemp"
                      scrollable
                    />

                    <v-card-actions class="px-4">
                      <v-spacer />
                      <v-btn text color="primary" @click="expireMenu = false">
                        CANCEL
                      </v-btn>
                      <v-btn text color="primary" @click="confirmExpireDate">
                        OK
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-col>

            <v-col cols="12" md="6" class="switch-col">
              <span class="switch-label">
                {{ form.isActive ? 'Active' : 'Inactive' }}
              </span>

              <v-switch
                v-model="form.isActive"
                inset
                dense
                hide-details
                :color="form.isActive ? 'success' : 'grey'"
                class="active-switch"
              />
            </v-col>
          </template>
        </v-row>
        </v-form>
      </v-card-text>
      <v-divider />

      <!-- Actions -->
      <v-card-actions class="dialog-actions">
        <v-spacer />
        <v-btn text @click="closeDialog">
          {{this.$t('cancel')}}
        </v-btn>
        <v-btn
          color="primary"
          :loading="dialog.loading"
          @click="saveDialog"
        >
          {{this.$t('save')}}
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>

  <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
  name: 'ApiClientManagement',

  data () {
    return {
      search: '',
      page: 1,
      itemsPerPage: 10,
      progressMessage: '',
      expireMenu: false,
      expireDateTemp: null,
      items: [],
      listLoading: false,
      listError: '',

      dialog: {
        open: false,
        mode: 'create', // 'create' | 'edit'
        valid: false,
        loading: false,
        dialogProgress: false,
      },

      form: {
        clientId: '',
        clientName: '',
        contactEmail: '',
        scopes: [],
        ipWhitelist: '',
        status: 'Active',
        expireDate: '',
        callbackEndpoint: '',
        authType: '',
        authSecret: ''
      },

      statusOptions: ['Active', 'Inactive'],
      scopeOptions: ['read', 'write', 'delete', 'write:user'],

      rules: {
        required: v => !!v || 'Required',
        email: v => (!v || /.+@.+\..+/.test(v)) || 'Invalid email'
      }
    }
  },

  created () {
    // ✅ Vue2: เรียกตอน component ถูกสร้าง
    this.fetchItems()
  },

  computed: {
    getheaders () {
      return [
        { text: '#', value: 'no', width: 40 },
        { text: 'Actions', value: 'actions', sortable: false, width: 120, align: 'center' },
        { text: 'Client ID', value: 'clientId' },
        { text: this.$t('ApiClientManagement.clientName'), value: 'clientName' },
        { text: this.$t('ApiClientManagement.contactEmail'), value: 'contactEmail' },
        { text: this.$t('scopes'), value: 'scopes', sortable: false },
        { text: this.$t('ApiClientManagement.ipAdress'), value: 'ipWhitelist', sortable: false },
        { text: this.$t('ApiClientManagement.status'), value: 'status' },
        { text: this.$t('ApiClientManagement.expireDate'), value: 'expireDate' },
        { text: this.$t('ApiClientManagement.callbackEndpoint'), value: 'callbackEndpoint' },
        { text: this.$t('ApiClientManagement.authSecret'), value: 'authSecret' },
        { text: this.$t('ApiClientManagement.authType'), value: 'authType' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Updated At', value: 'updatedAt' }
      ]
    },

    filteredItems () {
      const q = (this.search || '').toLowerCase().trim()
      if (!q) return this.items

      return this.items.filter(item =>
        item.clientId.toLowerCase().includes(q) ||
        item.clientName.toLowerCase().includes(q)
      )
    },

    totalPages () {
      const total = this.filteredItems.length
      return Math.max(1, Math.ceil(total / this.itemsPerPage))
    },

    showingFrom () {
      if (!this.filteredItems.length) return 0
      return (this.page - 1) * this.itemsPerPage + 1
    },

    showingTo () {
      return Math.min(this.page * this.itemsPerPage, this.filteredItems.length)
    }
  },

  watch: {
    search () {
      this.page = 1
    }
  },

  methods: {
    getEmptyForm () {
      return {
        clientId: '',
        clientName: '',
        contactEmail: '',
        scopes: [],
        ipWhitelist: '',
        status: 'Active',
        expireDate: '',
        isActive: false,  // ✅ เพิ่มบรรทัดนี้
        callbackEndpoint: '',
        authType: '',
        authSecret: ''
      }
    },

    // ✅ ดึงข้อมูลจาก API มาใส่ this.items
    async fetchItems () {
      this.listLoading = true
      this.listError = ''

      try {
        const endpoint = `${process.env.VUE_APP_API}/api/${process.env.VUE_APP_API_VERSION}/apiClientManagement`
        // const token = localStorage.getItem('user-token') || ''
        const res = await this.axios.get(endpoint)
        const payload = res.data
        const rows = Array.isArray(payload) ? payload : (payload.data || [])

        this.items = rows.map(x => ({
          clientId: x.clientId || x.client_id || '',
          clientName: x.clientName || x.client_name || '',
          contactEmail: x.contactEmail || x.contact_email || '',
          scopes: Array.isArray(x.scopes)
            ? x.scopes
            : (typeof x.scopes === 'string' ? x.scopes.split(',') : []),
          ipWhitelist: x.ipWhitelist || x.ip_whitelist || '',
          isActive: x.is_active || null,
          expireDate: x.expire_date
            ? String(x.expire_date).slice(0, 10)
            : null,
          createdAt: x.createdAt || x.created_at || '',
          updatedAt: x.updatedAt || x.updated_at || '',
          callbackEndpoint: x.callbackEndpoint || x.callback_endpoint || '',
          authType: x.authType || x.auth_type || '',
          authSecret: x.authSecret || x.auth_secret || ''
        }))

        this.page = 1
      } catch (err) {
        console.log(err)
        // axios error จะมี response/status ช่วย debug ได้
        this.listError =
          err?.response?.data?.reasonText ||
          err?.response?.data?.message ||
          err?.message ||
          'Unknown error'
      } finally {
        this.listLoading = false
      }
    },

    resetForm () {
      this.form = this.getEmptyForm()
      if (this.$refs.clientForm) {
        this.$refs.clientForm.resetValidation()
      }
    },

    openCreate () {
      this.dialog.mode = 'create'
      this.resetForm()
      this.dialog.open = true
    },

    openExpireMenu () {
      this.expireDateTemp = this.form.expireDate || new Date().toISOString().slice(0, 10)
      this.expireMenu = true
    },
    confirmExpireDate () {
      this.form.expireDate = this.expireDateTemp || null
      this.expireMenu = false
    },

    openEdit (item) {
      this.dialog.mode = 'edit'

      const expireDate = item?.expireDate
      ? String(item.expireDate).slice(0, 10)
      : null

      this.form = {
        ...this.getEmptyForm(),
        clientId: item?.clientId || '',
        clientName: item?.clientName || '',
        contactEmail: item?.contactEmail || '',
        scopes: Array.isArray(item?.scopes) ? item.scopes.slice() : [],
        ipWhitelist: item?.ipWhitelist || '',
        expireDate,
        callbackEndpoint: item?.callbackEndpoint || '',
        authType: item?.authType || '',
        authSecret: item?.authSecret || '',
        isActive: Boolean(item?.isActive)
      }

      this.expireDateTemp = expireDate

      if (this.$refs.clientForm) {
        this.$refs.clientForm.resetValidation()
      }

      this.dialog.open = true
    },

    closeDialog () {
      this.dialog.open = false
      if (this.$refs.clientForm) {
        this.$refs.clientForm.resetValidation()
      }
    },

    async saveDialog () {
      const ok = this.$refs.clientForm
        ? this.$refs.clientForm.validate()
        : true
      if (!ok) return

      this.dialog.dialogProgress = true
      this.progressMessage = this.dialog.mode === 'create'
        ? this.$t('Saving client...')
        : this.$t('Updating client...')

      try {
        const apiBase = process.env.VUE_APP_API
        const apiVersion = process.env.VUE_APP_API_VERSION

        // ✅ Create (คงเดิม)
        if (this.dialog.mode === 'create') {
          const payload = {
            client_name: this.form.clientName,
            ip_whitelist: this.form.ipWhitelist || '',
            contact_email: this.form.contactEmail,
            callback_endpoint: this.form.callbackEndpoint || '',
            auth_type: this.form.authType || '',
            auth_secret: this.form.authSecret || ''
          }

          const endpoint = `${apiBase}/api/${apiVersion}/auth/register_client`

          const res = await this.axios.post(endpoint, payload, {
            validateStatus: () => true
          })

          const data = res.data || {}
          if (!data.isSuccess) {
            throw new Error(data.message || `Request failed (${res.status})`)
          }

          this.dialog.dialogProgress = false

          const clientId = data.client_id
          const clientSecret = data.client_secret

          await this.$swal({
            title: this.$t('ApiClientManagement.clientCreate'),
            type: 'success',
            html: `
              <div style="text-align:left">
                <div><b>Client ID:</b> ${clientId}</div>
                <div style="display:flex; align-items:flex-start;">
                  <b style="white-space: nowrap; margin-right:6px;">
                    Secret Client:
                  </b>
                  <span id="clientSecretText"
                    style="
                      word-break: break-all;
                      overflow-wrap: break-word;
                    "
                  >
                    ${clientSecret}
                  </span>
                </div>
              </div>
            `,
            showCancelButton: false,          // ✅ ไม่มีปุ่ม Close/Cancel
            showCloseButton: false,           // ✅ ไม่มีปุ่ม X มุมขวา
            allowOutsideClick: false,         // ✅ คลิกข้างนอกปิดไม่ได้
            allowEscapeKey: false,            // ✅ กด ESC ปิดไม่ได้
            confirmButtonText: this.$t('Copy'),
            preConfirm: async () => {
              const el = document.getElementById('clientSecretText')
              const text = el ? el.innerText : clientSecret

              if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(text)
              } else {
                const ta = document.createElement('textarea')
                ta.value = text
                document.body.appendChild(ta)
                ta.select()
                document.execCommand('copy')
                document.body.removeChild(ta)
              }
              return true
            }
          })

          this.closeDialog()
          await this.fetchItems()
          return
        }

        const scopesClean = Array.isArray(this.form.scopes)
        ? this.form.scopes.map(s => s.trim()).filter(Boolean)
        : []
        const payload = {
          client_id: this.form.clientId,
          contact_email: this.form.contactEmail,
          ip_whitelist: this.form.ipWhitelist || '',
          expire_date: this.form.expireDate
            ? String(this.form.expireDate).slice(0, 10)
            : null,
          is_active: this.form.isActive ? 1 : 0,
          scopes: scopesClean.length > 0 ? scopesClean.join(',') : null,
          callback_endpoint: this.form.callbackEndpoint || '',
          auth_type: this.form.authType || '',
          auth_secret: this.form.authSecret || ''
        }

        const endpoint = `${apiBase}/api/${apiVersion}/update_client`

        const res = await this.axios.post(endpoint, payload, {
          validateStatus: () => true
        })

        const data = res.data || {}
        if (!data.isSuccess) {
          throw new Error(data.message || `Request failed (${res.status})`)
        }

        this.dialog.dialogProgress = false

        await this.$swal({
          type: 'success',
          title: this.$t('Updated')
        })

        this.closeDialog()
        await this.fetchItems()
      } catch (e) {
        console.log(e)
        this.dialog.dialogProgress = false
        await this.$swal({ type: 'error', title: e.message || 'Save failed' })
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async confirmDeleteClient (item) {
      const clientId = item.clientId || item.client_id
      if (!clientId) {
        await this.$swal({ type: 'error', title: this.$t('Error'), text: 'client_id is missing' })
        return
      }

      // 1) confirm
      const result = await this.$swal({
        text: this.$t('ApiClientManagement.confirmDeleteClient'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t('delete'),
        cancelButtonText: this.$t('cancel')
      })
      const confirmed = result === true || (result && result.value)
      if (!confirmed) return

      // 2) loading
      this.$swal({
        title: this.$t('Processing...'),
        text: this.$t('Please wait'),
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: () => this.$swal.showLoading()
      })

      try {
        const endpoint =
          `${process.env.VUE_APP_API}/api/${process.env.VUE_APP_API_VERSION}` +
          `/delete_client/${encodeURIComponent(clientId)}`

        const res = await this.axios.delete(endpoint)

        if (!res?.data?.isSuccess) {
          throw new Error(res?.data?.message || 'Delete failed')
        }

        // 3) ลบแถวออกจาก UI ทันที (ไม่ต้อง fetch ใหม่)
        const idx = this.items.findIndex(i => (i.clientId || i.client_id) === clientId)
        if (idx !== -1) this.items.splice(idx, 1)

        await this.$swal({
          type: 'success',
          title: this.$t('Delete Success'),
          text: this.$t('ApiClientManagement.deleteSuccess')
        })
      } catch (e) {
        await this.$swal({
          type: 'error',
          title: this.$t('Delete failed'),
          text: e?.message || String(e)
        })
      }
    },
    async resetSecretClientKey (item) {
      // 1) confirm
      const result = await this.$swal({
        text: this.$t('ApiClientManagement.confirmResetClientSecret'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      })

      const confirmed = result === true || (result && result.value)
      if (!confirmed) return

      // 2) loading (ยิง api)
      this.$swal({
        title: this.$t('Processing...'),
        text: this.$t('Please wait'),
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: () => {
          this.$swal.showLoading()
        }
      })

      try {
        const clientId = item.clientId
        const endpoint = `${process.env.VUE_APP_API}/api/${process.env.VUE_APP_API_VERSION}/auth/reset_client_secret`
        const res = await this.axios.post(
          endpoint,
          {
            client_id: item.clientId
          })
        const clientSecret =
          (res && res.data && (res.data.clientSecret || res.data.client_secret || res.data.secret)) || ''

        if (!clientSecret) throw new Error('No secret returned')

        // 3) success -> แสดง secret + ปุ่ม copy
        await this.$swal({
          title: this.$t('ApiClientManagement.resetSuccess'),
          type: 'success',
          html: `
            <div style="text-align:left">
              <div><b>Client ID:</b> ${clientId}</div>
              <div style="display:flex; align-items:flex-start;">
                <b style="white-space: nowrap; margin-right:6px;">
                  Secret Client:
                </b>
                <span style="
                  word-break: break-all;
                  overflow-wrap: break-word;
                ">
                  ${clientSecret}
                </span>
              </div>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: this.$t('Copy'),
          cancelButtonText: this.$t('Close'),
          preConfirm: async () => {
            const el = document.getElementById('secretInput')
            const text = el ? el.value : clientSecret

            if (navigator.clipboard && navigator.clipboard.writeText) {
              await navigator.clipboard.writeText(text)
            } else {
              el.select()
              document.execCommand('copy')
            }
            return true
          }
        })
      } catch (e) {
        // this.$swal({ type: 'error', title: this.$t('Reset failed'), text: e.message })
      }
    }
  }
}
</script>

<style scoped>

.table-card {
  border-radius: 10px;
  overflow: hidden;
}

.footer-bar {
  border-top: 1px solid #eef0f4;
}

.status-chip {
  font-weight: 600;
}

.dialog-title {
  align-items: center;
  padding: 16px 20px;
}

.dialog-card {
  position: relative;
  border-radius: 12px;
}

.dialog-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 36px;
  height: 36px;
  min-width: 36px !important;
  border-radius: 50%;
}

.dialog-actions {
  padding: 16px 24px;
}

.switch-col {
  display: flex;
  align-items: center;
  height: 56px;
  padding-left: 24px;
  gap: 14px;
}

.switch-label {
  white-space: nowrap;
  font-weight: 600;
  color: #616161;
  transform: translateY(-10px);
}

.switch-col >>> .active-switch {
  margin: 0 !important;
  transform: translateY(-10px);
}

.switch-col >>> .active-switch .v-input__slot {
  margin: 0 !important;
}

.expire-menu {
  z-index: 2000 !important;
}
</style>
